"use client";

import { Download } from "lucide-react";
import { bloodHub } from "@/content/blood-hub";

export function FooterBloodHubLink() {
  return (
    <p className="mt-4">
      <a
        href={bloodHub.playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link group inline-flex items-center gap-2 text-sm text-muted transition-colors hover:text-accent"
      >
        <Download
          size={14}
          className="footer-contact-icon shrink-0"
          aria-hidden
        />
        <span>
          Download {bloodHub.name}
          <span className="sr-only"> on Google Play (opens in a new tab)</span>
        </span>
      </a>
    </p>
  );
}
